/**
 * Gallery module
 *
 * @description
 * <p>Sets up Gallery buttons and click events</p>
 * <p>On page load, Adds click events to .history-gallery-btn elements (despite the name, used in not only History page, but also Article Detail and Newsroom)</p>
 * <p>Self-initializes when page loads.</p>
 *
 * @module gallery
 *
 * @namespace site.gallery
 *
 */
( /* @lends module:gallery */ function(site,$){
	"use strict";
(function($){
	var trace = {push: function() {}},
		dom = {},
		items = [],
		current = -1;

	function init() {
		trace.push('[gallery.js] init()')
		trace = site.utilities && site.utilities.trace ? site.utilities.trace : {push: function() {}};

		dom.site = $('#site');

		//find all history gallery btns and add click event to launch overlay

		dom.galleryBtn = $('.history-gallery-btn');
		dom.galleryBtn.each(function(){
			$(this).on('click', function(event) {
				event.preventDefault();
				open($(this).next(".gallery-items"));
				site.lockScreen();
			});

		});

	}

	/// build the gallery overlay and reveal the container

	function open(obj) {

		current = -1
		// trace.push('open '+obj)
		var item = obj.find('.item');
		items = [];

		// look inside the seleted history gallery btn and find the gallery image information
		// Then add it to the items array
		item.each(function(){
			// trace.push('items');
			var img = $(this).attr('data-hires');
			var imgW = $(this).attr('data-hires-w')*1;
			var imgH = $(this).attr('data-hires-h') *1;
			var year = $(this).find('.year').html();
			var title = $(this).find('.title').html();
			var desc = $(this).find('.desc').html();
			items.push({'img':img,'imgW':imgW,'imgH':imgH,'year':year,'title':title,'desc':desc});
		});
		dom.site.append('<div id="gallery-overlay"><div class="holder"><div class="close-btn hoverable"></div><div class="content"><div class="img"></div><div class="info"><div class="year"></div><div class="title"></div><div class="desc-ctn"><p class="desc"></p></div><div class="nav"><div class="left-arrow hoverable"></div><div class="current"></div><div class="divider">/</div><div class="total"></div><div class="right-arrow hoverable"></div></div></div></div></div></div>');

		// register dom elements that will need to be changed when user navigates left or right through the gallery

		dom.overlay = $('#gallery-overlay');
		dom.content = dom.overlay.find('.content');
		dom.title = dom.overlay.find('.title');
		dom.desc = dom.overlay.find('.desc');
		dom.year = dom.overlay.find('.year');
		dom.img = dom.overlay.find('.img');
		dom.current = dom.overlay.find('.current');
		dom.total = dom.overlay.find('.total');

		// add click events to the gallery overlay navigation

		dom.closeBtn = dom.overlay.find('.close-btn');
		dom.closeBtn.on('click', function() {
			close();
			site.unlockScreen();
		});

		dom.left = $('.left-arrow');
		dom.left.on('click', function() {
			set('left');
		});

		dom.right = $('.right-arrow');
		dom.right.on('click', function() {
			set('right');
		});

		// animate overlay in

		dom.overlay.addClass('active');

		// set swipe behavior for tablet and mobile

		dom.overlay.on('swipeleft', function(){
			// trace.push('right');
			set('right');
		}).on('swiperight', function(){
			// trace.push('left');
			set('left');
		});

		// set first gallery item

		next('right');

	}

	/*
		set closes the current content and then in a half second set the next gallery item
	 */
	function set(direction) {
		closeContent();
		setTimeout(function(){ next(direction); }, 500);

	}

	/// next increment to the next gallery item. plus or minus based on direction
	function next(direction) {
		// trace.push('nextGallery');
		if(direction == "right") {
			current++;
		} else {
			current--;
		}

		// sends user back to first item
		if(current > items.length-1) {
			current = 0;
		}
		// sends user to the last item
		if(current < 0) {
			current = items.length-1;
		}

		// trace.push(current)

		dom.title.html(items[current].title);
		dom.desc.html(items[current].desc);
		dom.year.html(items[current].year);
		dom.year.html(items[current].year);
		dom.current.html(current+1);
		dom.total.html(items.length);
		trace.push("items[current].imgW = "+items[current].imgW+" items[current].imgH = "+items[current].imgH);
		if(items[current].imgH > items[current].imgW) {
			trace.push('tall')
			dom.img.addClass('tall');
		} else {
			dom.img.removeClass('tall');
		}
		// add image with onload function that will reveal the gallery item once it's loaded

		dom.img.html('<img src="'+items[current].img+'" onload="site.gallery.openContent()"/>');

		// sets zoom functionality for the image

		site.zoom.set(dom.img);

	}

	/**
	 * @function site.gallery.openContent
	 * @description Animates in the new gallery item
	 * @example
	 * {@lang javascript}
	 * dom.img.html('<img src="'+items[current].img+'" onload="site.gallery.openContent()"/>');
	 * @public
	 */
	function openContent() {
		trace.push('openGallery');

		dom.content.addClass('active');
	}

	// animates out the old gallery item

	function closeContent() {
		// trace.push('closeContent');
		dom.content.removeClass('active');
	}

	// closes the overlay container

	function close() {
		// trace.push('close');
		dom.overlay.removeClass('active');
		setTimeout(function(){ remove(); }, 1000);
	}

	// removes the overlay from the dom

	function remove() {
		// trace.push('remove');
		dom.overlay.remove();
	}

	// Public API definitions
	site.gallery = {
		openContent : openContent
	};


	$(function(){
		init();
		$( document ).ajaxComplete(function(event, xhr, options) {
          if (options.url.toLowerCase().indexOf("api/newsroom/node") >= 0 || options.url.toLowerCase().indexOf("api/newsroom/list") >= 0) {
                init();
            }
        });
	});
	})(jQuery);
})(window.site=window.site || {}, jQuery);
